export const getExportPageTypeText = ["transcription", "minutes", "summary", "detailedMinutes"];
